<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Manage Sub-Admins <span v-b-modal.new-business style="cursor:pointer;font-size:15px;" class="fa fa-plus pull-right"> New Sub-Admin</span></h4>
            <p class="category">View Sub Admins registered to your applications</p>
          </md-card-header>
          <md-card-content>
             <md-table v-model="searched" md-card md-fixed-header>
                <md-table-toolbar>
                    <div class="md-toolbar-section-start">
                    <h1 class="md-title">Sub Admins</h1>
                    </div>

                    <md-field md-clearable class="md-toolbar-section-end">
                    <md-input placeholder="Search by name..." v-model="search" @input="searchOnTable" />
                    </md-field>
                </md-table-toolbar>


                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="First Name" md-sort-by="first_name">{{  item.first_name}}</md-table-cell>
                    <md-table-cell md-label="First Name" md-sort-by="first_name"> {{  item.last_name}}</md-table-cell>
                    <md-table-cell md-label="Email" md-sort-by="prganization">{{ item.email }}</md-table-cell>
                    <md-table-cell md-label="Contact" md-sort-by="prganization">{{ item.contact }}</md-table-cell>
                    <!-- <md-table-cell md-label="Status"  md-sort-by="status">
                      <h5><b-badge :variant="item.status=='active'? 'success':'danger'">{{ item.status }}</b-badge></h5>
                    </md-table-cell> -->
                    <md-table-cell md-label="Action" md-sort-by="action">  
                        <md-button class="md-dense md-raised md-danger btn-sm"  @click="lc_DelUser(item.id)" >Remove</md-button>
                        <md-button class="md-dense md-raised md-warning btn-sm"  @click="lc_blockUser(item.id)" >Block</md-button>

                        <!-- <md-button class="md-dense md-raised md-primary btn-sm"  @click="setUser(item)">View</md-button> -->
                        <!-- <md-button class="md-dense md-raised md-danger btn-sm" v-if="item.status!='blocked'"  @click="lc_blockUser(item)">Block</md-button> -->
                    </md-table-cell>
                </md-table-row>
                </md-table>
                 <b-modal id="modal-1"  hide-footer>
                   <template v-slot:modal-header>
                      <h5 class="ml-auto mr-auto"> <b>{{selected_user.first_name}} </b></h5>
                    </template>
                   <b-container >
                     <div class="row">
                       <div class="col-md-6">
                        <h6> <b>Email</b>  </h6>
                       </div>
                       <div class="col-md-6">
                        <p v-if="edit==false">{{selected_user.email}}</p> 
                        <b-input v-else type="email" v-model="selected_user.email"></b-input>
                       </div>
                       <div class="col-md-6 mt-2">
                        <h6><b>Name </b> </h6> 
                       </div>
                       <div class="col-md-6 mt-2">
                        <p v-if="edit==false">{{selected_user.first_name}} {{selected_user.last_name}}</p> 
                        <!-- <select  style="border:1px solid #ced4da" v-else class="form-control" name="select-yui_3_17_2_1_1568180032362_44107-field"> 
                              
                                <option value="Albuquerque">Albuquerque</option>
                              
                                <option value="Atlanta">Atlanta</option>
                              
                                <option value="Austin">Austin</option>
                              
                                <option value="Baltimore">Baltimore</option>
                              
                                <option value="Boston">Boston</option>
                              
                                <option value="Charlotte">Charlotte</option>
                              
                                <option value="Chicago">Chicago</option>
                              
                                <option value="Cincinnati">Cincinnati</option>
                              
                                <option value="Cleveland">Cleveland</option>
                              
                                <option value="Colorado Springs">Colorado Springs</option>
                              
                                <option value="Columbus">Columbus</option>
                              
                                <option value="Dallas">Dallas</option>
                              
                                <option value="Denver">Denver</option>
                              
                                <option value="Detroit">Detroit</option>
                              
                                <option value="El Paso">El Paso</option>
                              
                                <option value="Fresno">Fresno</option>
                              
                                <option value="Fort Worth">Fort Worth</option>
                              
                                <option value="Houston">Houston</option>
                              
                                <option value="Indianapolis">Indianapolis</option>
                              
                                <option value="Jacksonville">Jacksonville</option>
                              
                                <option value="Kansas City">Kansas City</option>
                              
                                <option value="Las Vegas">Las Vegas</option>
                              
                                <option value="Long Beach">Long Beach</option>
                              
                                <option value="Los Angeles">Los Angeles</option>
                              
                                <option value="Louisville">Louisville</option>
                              
                                <option value="Memphis">Memphis</option>
                              
                                <option value="Mesa">Mesa</option>
                              
                                <option value="Miami">Miami</option>
                              
                                <option value="Milwaukee">Milwaukee</option>
                              
                                <option value="Minneapolis">Minneapolis</option>
                              
                                <option value="Nashville">Nashville</option>
                              
                                <option value="New Orleans">New Orleans</option>
                              
                                <option value="New York">New York</option>
                              
                                <option value="Oakland">Oakland</option>
                              
                                <option value="Oklahoma City">Oklahoma City</option>
                              
                                <option value="Omaha">Omaha</option>
                              
                                <option value="Philadelphia">Philadelphia</option>
                              
                                <option value="Phoenix">Phoenix</option>
                              
                                <option value="Portland">Portland</option>
                              
                                <option value="Raleigh">Raleigh</option>
                              
                                <option value="Sacramento">Sacramento</option>
                              
                                <option value="San Antonio">San Antonio</option>
                              
                                <option value="San Diego">San Diego</option>
                              
                                <option value="San Francisco">San Francisco</option>
                              
                                <option value="San Jose">San Jose</option>
                              
                                <option value="Seattle">Seattle</option>
                              
                                <option value="Tampa">Tampa</option>
                              
                                <option value="Tucson">Tucson</option>
                              
                                <option value="Tulsa">Tulsa</option>
                              
                                <option value="Virginia Beach">Virginia Beach</option>
                              
                                <option value="Washington, DC">Washington, DC</option>
                              
                        </select> -->
                       </div>
                       <div class="col-md-6 mt-2">
                        <h6> <b>Contact Number </b>  </h6> 
                       </div>
                       <div class="col-md-6 mt-2">
                        <p v-if="edit==false">{{selected_user.contact}}</p> 
                        <!-- <b-input v-else type="text" v-model="selected_user.organization"></b-input> -->

                       </div>
                     </div> 
                   </b-container>
                   <b-container fluid class="mt-4">
                      <!-- <md-button v-if="edit==true" class="ml-2 md-dense md-raised md-primary pull-right" @click="lc_updateServiceProvider();edit=false">Update</md-button> -->
                      <!-- <md-button v-else class="ml-2 md-dense md-raised md-primary pull-right" @click="edit=true">Edit</md-button> -->
                      <md-button class="md-dense md-raised md-primary pull-right" @click="hide('modal-1')">Cancel</md-button>


                   </b-container>
                </b-modal>
          </md-card-content>
        </md-card>
      </div>

      <!-- <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
      
      </div> -->
    </div>
    <b-modal id="new-business"  hide-footer>
        <template v-slot:modal-header>
          <h5 class="ml-auto mr-auto"> <b>Create New Sub Admin </b></h5>
        </template>
        <b-container fluid >
          <div class="row">
            <div class="row">
                <div class="col-md-6 col-12">
                    <label for="" class="text-primary">First Name*</label>
                    <input type="text" name="" placeholder="John" v-model="subAdmin.first_name" class="form-control" id="">
                </div>
                <div class="col-md-6 col-12">
                    <label for="" class="text-primary">Last Name*</label>
                    <input type="text" name="" placeholder="Doe" v-model="subAdmin.last_name" class="form-control" id="">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-6 col-12">
                    <label for="" class="text-primary">Email*</label>
                    <input type="text" name="" placeholder="john@gmail.com" v-model="subAdmin.email" class="form-control" id="">
                </div>
                <div class="col-md-6 col-12">
                    <label for="" class="text-primary">Phone*</label>
                    <input type="number" min="0" name="" placeholder="+123456789" v-model="subAdmin.contact" class="form-control" id="">
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-12 mt-3">
                    <label for="" class="text-primary">Password*</label>
                    <input type="password"  placeholder="Your Password" v-model="subAdmin.password" class="form-control" id="">
                </div>
                <div class="col-md-6 col-12 mt-3">
                    <label for="" class="text-primary">Confirm Password*</label>
                    <input type="password" name="" placeholder="Confirm Password" v-model="subAdmin.confirm_password" class="form-control" id="">
                </div>
            </div>
          </div> 
        </b-container>
        <b-container fluid class="mt-4">
          <md-button class="ml-2 md-dense md-raised md-primary pull-right" @click="navigate()">Create</md-button>
          <md-button class="md-dense md-raised md-primary pull-right" @click="hide('new-business')">Cancel</md-button>
        </b-container>
    </b-modal>
  </div>
</template>

<script>
const toLower = text => {
    return text.toString().toLowerCase()
  }

  const searchByName = (items, term) => {
    if (term) {
      return items.filter(item => toLower(item.first_name).includes(toLower(term)))
    }

    return items
  }

// import { SimpleTable, OrderedTable } from "@/components";
import {mapGetters} from 'vuex'
export default {
  name:'SubAdmins',
    data: () => ({

      subAdmin: {
        first_name: null,
        last_name: null,
        password: null,
        confirm_password: null,
        email: null,
        type:'sub_admin',
        status:'active'
      },
      search: null,
      edit:false,
      selected_user:'',
      searched: [],
      showDialog: false,
      
    }),
    watch:{
      active_sub_admins(){
        if(this.active_sub_admins.length>0){
        this.searched = this.active_sub_admins

        }
        else{
          this.searched=[]
        }
      }

    },
    methods: {
      navigate() {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let subAdmin = this.subAdmin;
                if(subAdmin.first_name == null || subAdmin.last_name == null || subAdmin.email == null || subAdmin.contact == null ) {
                  this.$store.commit("setNotifications",{message:"All Fields Required!",type:'error'})
                }
                else if(!re.test(subAdmin.email.toLowerCase())) {
                    this.$store.commit("setNotifications",{message:"Invalid Email!",type:'error'})
                }
                else if(subAdmin.password == null) {
                    this.$store.commit("setNotifications",{message:"Please Enter Password!",type:'error'})
                }
                else if(this.subAdmin.confirm_password == null) {
                    this.$store.commit("setNotifications",{message:"Please Confirm Your Password!!",type:'error'})
                }
                else if(subAdmin.confirm_password != subAdmin.password) {
                   this.$store.commit("setNotifications",{message:"Password Mismatch!",type:'error'})
                }
                else {
                    this.$store.dispatch('createUser',subAdmin);
                    this.subAdmin={
                        first_name: null,
                        last_name: null,
                        password: null,
                        confirm_password: null,
                        email: null,
                        type:'sub_admin',
                        status:'active'
                    }
                    this.hide('new-business')
                }
        },
      lc_DelUser(item){
        console.log(item)
        this.$store.dispatch("DeleteUser",item) 
      },
      lc_blockUser(item){
        // this.$bvModal.hide('modal-1')	
        console.log(item)
        this.$store.dispatch("blockUser",item) 
      },
      // lc_updateServiceProvider () { 
      //   this.hide()
      //   this.$store.dispatch("updateUsers",this.selected_user)
      // },
      // setUser(item){
      //   this.selected_user=item
      //   this.$bvModal.show('modal-1')	
      // },
      hide(id){
        this.$bvModal.hide(id)	
        // this.edit=false;

      },
      
      searchOnTable () {
        this.searched = searchByName(this.active_sub_admins, this.search)
      }
    },
    computed:{
      ...mapGetters(['active_sub_admins'])
    },
    created () {
      this.searched = this.active_sub_admins
    }
  }
</script>

<style scoped>


</style>
